export default __webpack_public_path__ + "static/media/list.9dbc5a3a.svg";